import { buildInstanceRoutingComposable } from "@/components/ConfigTemplates/routing";
export const useInstanceRouting = buildInstanceRoutingComposable("/object_store_instances/index");
